import React from 'react';
import { Box, Flex, Text } from '@chakra-ui/react';
import { MODES } from '../hooks/useTimer';
import { getModeAccent } from '../themes';

const TABS = [
  { mode: MODES.FOCUS,       label: 'Focus' },
  { mode: MODES.SHORT_BREAK, label: 'Short' },
  { mode: MODES.LONG_BREAK,  label: 'Long' },
];

const ModeTabs = ({ mode, onModeChange, theme }) => (
  <Box
    borderRadius="xl"
    p="3px"
    style={{
      background: theme.cardBg,
      border: `1px solid ${theme.cardBorder}`,
      backdropFilter: 'blur(12px)',
    }}
  >
    <Flex gap="2px" align="stretch">
      {TABS.map(({ mode: m, label }) => {
        const isActive = mode === m;
        const accent = getModeAccent(theme, m);
        return (
          <Box
            key={m}
            as="button"
            type="button"
            flex={1}
            h="36px"
            px={1}
            py={0}
            onClick={() => onModeChange(m)}
            aria-pressed={isActive}
            borderRadius="lg"
            position="relative"
            cursor="pointer"
            display="flex"
            alignItems="center"
            justifyContent="center"
            transition="all 0.2s"
            style={{
              background: isActive ? `${accent}22` : 'transparent',
              border: isActive ? `1px solid ${accent}44` : '1px solid transparent',
              boxSizing: 'border-box',
            }}
            _hover={!isActive ? { background: 'rgba(255,255,255,0.05)' } : {}}
          >
            <Text
              as="span"
              fontSize="xs"
              fontWeight={isActive ? '600' : '400'}
              textAlign="center"
              letterSpacing="0.3px"
              lineHeight="1"
              m={0}
              p={0}
              style={{
                color: isActive ? accent : theme.textMuted,
                transition: 'color 0.3s ease',
              }}
            >
              {label}
            </Text>
          </Box>
        );
      })}
    </Flex>
  </Box>
);

export default ModeTabs;
